interface IAudioPlayer {
  audioSrc: string;
  audioDuration: number;
  scTimeList?: number[]; //[语句1开始，语句1结束，语句2开始，语句2结束，语句3开始，语句3结束]
  isPlaying?: boolean;
  skipBlank?: boolean;
  onDurationNumChange?: (durationNum: number) => void;
  onCurrentNumChange?: (currentNum: number) => void;
  onIsPlayingChange?: (isPlaying: boolean) => void;
  onModifyPlayingTime?: (time: number) => void;
  onLoadError?: () => void;
}

class AudioPlayerIns {
  private myAudio: HTMLAudioElement | null = null;
  private currentNum: number = 0;
  private durationNum: number = 0;
  private isPlaying: boolean = false;
  private skipBlank: boolean = false;
  private scTimeList: number[] = [];
  private onDurationNumChange;
  private onCurrentNumChange;
  private onIsPlayingChange;
  private onModifyPlayingTime?: (time: number) => void;
  constructor({ audioSrc, audioDuration, scTimeList, isPlaying, skipBlank, onDurationNumChange, onCurrentNumChange, onIsPlayingChange, onModifyPlayingTime, onLoadError }: IAudioPlayer) {
    const tempAudio = new Audio(audioSrc);
    this.myAudio = tempAudio;
    if (isPlaying !== undefined) {
      this.isPlaying = isPlaying;
    }
    if (skipBlank !== undefined) {
      this.skipBlank = skipBlank;
    }
    if (scTimeList !== undefined) {
      this.scTimeList = scTimeList;
    }
    this.onDurationNumChange = onDurationNumChange;
    this.onCurrentNumChange = onCurrentNumChange;
    this.onIsPlayingChange = onIsPlayingChange;
    this.setDurationNum(audioDuration);
    this.onModifyPlayingTime = onModifyPlayingTime;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    tempAudio.addEventListener("timeupdate", function () {
      const targetAudioDuration = tempAudio.duration || audioDuration;

      const currentPercent = (tempAudio.currentTime / targetAudioDuration) * 100;
      // console.log(
      //   "onTimeUpdate",
      //   tempAudio.currentTime,
      //   targetAudioDuration,
      //   currentPercent
      // );
      // 由于不同端解码方式不同，可能出现前端duration结束了，但是后面还有音频，没有触发onEnded，此时以前端duration为准
      if (currentPercent <= 100) {
        _this.setDurationNum(targetAudioDuration);
        // 根据收集到的发言时间，跳过空白片段
        if (_this.skipBlank) {
          _this.scTimeList.some((time, index) => {
            // 找到第一个小于的时间,eg: [1,8,19,21,30,40]
            if (tempAudio.currentTime <= time) {
              // 判断开始时间还是结束时间,当为开始时间，则跳转到开始时间，当为结束时间，则无需操作
              // eg: 当前时间15 -> 找到19，为发言开始时间，则跳转到19; 当前时间20 -> 找到21，为发言结束时间
              if (index % 2 === 0) {
                _this.setCurrentTime(time);
              } else {
                _this.setCurrentNum(tempAudio.currentTime);
              }
              return true;
            }
            // 如果后面都没有播放的了，则直接跳到结尾
            else if (index === _this.scTimeList.length - 1 && tempAudio.currentTime >= time && currentPercent !== 100) {
              _this.setCurrentTime(targetAudioDuration);
              return true;
            }
            _this.setCurrentNum(tempAudio.currentTime);
            return false;
          });
        } else {
          _this.setCurrentNum(tempAudio.currentTime);
        }
      } else {
        _this.pause();
      }
    });

    // 当音频还没到达前端duration，但是音频触发了结束的钩子
    tempAudio.addEventListener("ended", function () {
      const targetAudioDuration = tempAudio.duration || audioDuration;
      console.log("onEnded", tempAudio.currentTime, targetAudioDuration);
      // 记录下音频实际结束时间
      _this.pause();
      _this.setCurrentNum(targetAudioDuration);
    });
    tempAudio.addEventListener("error", function (error) {
      console.log('audio load error', error);
      onLoadError && onLoadError();
    });
  }

  private setCurrentNum(currentNum: number) {
    this.currentNum = currentNum;
    this.onCurrentNumChange && this.onCurrentNumChange(currentNum);
  }

  setScTimeList(scTimeList: number[]) {
    this.scTimeList = scTimeList;
  }

  setCurrentTime(currentTime: number) {
    if (!this.myAudio) return;
    this.myAudio.currentTime = currentTime;
    this.setCurrentNum(currentTime);
    this.onModifyPlayingTime?.(currentTime);
  }

  private setDurationNum(durationNum: number) {
    this.durationNum = durationNum;
    this.onDurationNumChange && this.onDurationNumChange(durationNum);
  }

  private setPlaying(isPlaying: boolean) {
    this.isPlaying = isPlaying;
    this.onIsPlayingChange && this.onIsPlayingChange(isPlaying);
  }

  getPlayStatus() {
    return this.isPlaying;
  }

  toggle() {
    if (this.isPlaying) {
      this.pause();
    } else {
      this.play();
    }
  }

  pause() {
    this.myAudio?.pause();
    this.setPlaying(false);
  }

  destroy() {
    this.pause();
    this.myAudio = null;
  }

  private play() {
    // 记录当前播放器
    // 判断是否播放完毕，如果是，则从头播放
    console.log("handleAudioPlay", this.currentNum, this.durationNum);
    if (!this.myAudio) return;
    if (this.currentNum === this.durationNum && this.currentNum !== 0) {
      this.myAudio.currentTime = 0;
    }
    this.myAudio.play();
    this.setPlaying(true);
  }

  setPlayRate(playRate: number) {
    if (!this.myAudio) return;
    this.myAudio.playbackRate = playRate;
  }

  setSkipBlank(skipBlank: boolean) {
    this.skipBlank = skipBlank;
  }
}

export default AudioPlayerIns;
